export function getContainerVariant({ button }) {
    if ((button === null || button === void 0 ? void 0 : button.variant) === 'before') {
        return 'single-line-container-button-before';
    }
    if ((button === null || button === void 0 ? void 0 : button.variant) === 'after') {
        return 'single-line-container-button-after';
    }
    return 'single-line-container';
}
